import $ from "jquery";

export const $doc = $(document);
export const $win = $(window);